import Vue from "vue";
import VueTelInput from "vue-tel-input";
import "@/styles/vue-tel-input.css";

Vue.use(VueTelInput);

export default VueTelInput;
